module.exports = __webpack_public_path__ + "pc/img/about_visual.f89f4c22.jpg";